import type { GradingScale } from '@dosfilos/domain';
import { callable } from '../callable';

export interface TenantPolicyDto {
  id: string;
  title: string;
  description: Record<string, unknown>;
}

export interface TenantRubricCriterionDto {
  id: string;
  label: string;
  description: string;
  weight: number;
  levels?: { id: string; name: string; description: string }[];
}

export interface TenantRubricDto {
  id: string;
  title: string;
  criteria: TenantRubricCriterionDto[];
}

export interface UpdateTenantConfigInput {
  tenantId: string;
  mission?: { text: string; scripture?: string };
  policies?: TenantPolicyDto[];
  researchRubric?: TenantRubricDto;
  clearResearchRubric?: boolean;
  featureToggle?: { key: string; enabled: boolean };
  /** Escala de calificación del centro (forma vieja: solo 1-7 o 0-100). */
  grading?: { scale: '1-7' | '0-100'; exigencia?: number };
  /** LA escala unificada (numérica o de letras): reemplaza a `grading`. */
  gradingScale?: GradingScale;
  /** Reexpresa la nota de aprobación de todas las plantillas en la escala
   *  nueva. Sin esto, pasar a 0-100 dejaría a las doce pidiendo 4 de 100. */
  convertPassingGrades?: boolean;
  /** Años de inactividad tras los que el alumno pierde los derechos de su
   *  catálogo. 0 o null = el seminario no aplica la regla (se guarda ausente). */
  catalogRightsExpiryYears?: number | null;
  /** SEC-3: datos para pagar por transferencia (textos; vacío = no se muestra). */
  bankTransfer?: {
    holder: string;
    taxId: string;
    bank: string;
    accountType: string;
    accountNumber: string;
    email: string;
  };
  /** M2·H11: años para contar a un alumno como activo en Candidatos (1–50). */
  candidateActiveYears?: number;
  /** Candidatos: «cerca» = faltan este número de cursos o menos (1–20). */
  nearGraduationMaxCourses?: number;
  /** El formato del código de alumno (H6). Solo afecta a los códigos nuevos. */
  studentCode?: {
    prefix: string;
    strategy: 'random' | 'sequential';
    digits: number;
    includeYear?: boolean;
  };
}

export const tenantConfigApi = {
  updateTenantConfig: async (data: UpdateTenantConfigInput): Promise<{ ok: true }> => {
    const fn = callable<UpdateTenantConfigInput, { ok: true }>('updateTenantConfig');
    return (await fn(data)).data;
  },
};
